"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var q_play_core_1 = require("@nordicscreen/q-play-core");
var CreateTeamModal_module_css_1 = __importDefault(require("./CreateTeamModal.module.css"));
var react_i18next_1 = require("react-i18next");
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var q_play_components_2 = require("@nordicscreen/q-play-components");
var useTypedPage_1 = __importDefault(require("@/Hooks/useTypedPage"));
var RoleCheckboxList_1 = __importDefault(require("./RoleCheckboxList"));
var AutocompleteUserSelection_1 = __importDefault(require("../common/AutocompleteUserSelection"));
var avatarStyles = [
    { backgroundColor: "var(--secondary-color)", color: "var(--info-color)" },
    { backgroundColor: "var(--primary-color)", color: "var(--secondary-color)" },
    { backgroundColor: "var(--info-color)", color: "var(--secondary-color)" },
    { backgroundColor: "var(--primary-color)", color: "var(--secondary-color)" },
];
var UserAvatar = function (_a) {
    var imageUrl = _a.imageUrl, name = _a.name, _b = _a.styleIndex, styleIndex = _b === void 0 ? 0 : _b;
    var renderAvatarContent = function () {
        if (imageUrl) {
            return react_1.default.createElement("img", { src: imageUrl, alt: "User Avatar", className: CreateTeamModal_module_css_1.default.user_avatar_image });
        }
        else {
            var initial = name.charAt(0).toUpperCase();
            var style = avatarStyles[styleIndex % avatarStyles.length];
            return (react_1.default.createElement("div", { className: "".concat(CreateTeamModal_module_css_1.default.user_avatar_initial, " ns-font-family-bold"), style: style },
                react_1.default.createElement("span", { className: CreateTeamModal_module_css_1.default.user_avatar_initial_span }, initial)));
        }
    };
    return react_1.default.createElement("div", { className: CreateTeamModal_module_css_1.default.user_avatar_container }, renderAvatarContent());
};
var CreateTeamModal = function (props) {
    var _a;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var logger = q_play_core_1.logManager.getLogger();
    var page = (0, useTypedPage_1.default)();
    var headerText = props.mode === "edit" ? t("Update Team") : t("Create Team");
    var _b = (0, react_1.useState)([]), roles = _b[0], setRoles = _b[1];
    var _c = (0, react_1.useState)(""), teamName = _c[0], setTeamName = _c[1];
    var _d = (0, react_1.useState)([]), users = _d[0], setUsers = _d[1];
    var _e = (0, react_1.useState)([{ id: null, name: "" }]), members = _e[0], setMembers = _e[1];
    var _f = (0, react_1.useState)(true), isButtonDisabled = _f[0], setIsButtonDisabled = _f[1];
    var handleClose = function () {
        props.toggle();
        setMembers([{ id: null, name: "" }]);
        setTeamName("");
        setRoles(function (prevRoles) { return prevRoles.map(function (role) { return (__assign(__assign({}, role), { isChecked: false })); }); });
    };
    var addMember = function () {
        var newUser = {
            id: null,
            name: ""
        };
        setMembers(__spreadArray(__spreadArray([], members, true), [newUser], false));
    };
    var removeAddedMember = function (memberIndex) {
        setMembers(function (prevMembers) {
            return prevMembers.filter(function (_, index) { return index !== memberIndex; });
        });
    };
    var handleRoleCheckboxChange = function (roleId) {
        var _a;
        if ((_a = props.qteam) === null || _a === void 0 ? void 0 : _a.locked) {
            // If the qteam is locked, then it's not allowed to change roles.
            return;
        }
        setRoles(function (prevRoles) {
            var currentRole = prevRoles.find(function (role) { return role.id == roleId; });
            return prevRoles.map(function (role) {
                if (currentRole.group == 0 && role.group == 0) {
                    if (role.group == 0 && role.id != roleId) {
                        return __assign(__assign({}, role), { isChecked: false });
                    }
                    return __assign(__assign({}, role), { isChecked: true });
                }
                else if (currentRole.group == 0 && currentRole.name != "custom") {
                    return __assign(__assign({}, role), { isChecked: false });
                }
                else {
                    return role.id === roleId ? __assign(__assign({}, role), { isChecked: !role.isChecked }) : role;
                }
            });
        });
    };
    var handleMemberSelectionChange = function (memberId, newUserId) {
        var user = users.find(function (user) { return user.id === newUserId; });
        setMembers(function (prevMembers) {
            return prevMembers.map(function (member) { return member.id === memberId ? user : member; });
        });
    };
    var handleCreateTeam = function () { return __awaiter(void 0, void 0, void 0, function () {
        var roleIds, userIds, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    roleIds = roles.filter(function (role) { return role.isChecked && role.name !== "custom"; }).map(function (role) { return role.id; });
                    userIds = members.filter(function (member) { return member.id !== null; }).map(function (member) { return member.id; });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, ApiManager_1.default.createQteam(teamName, roleIds, userIds)];
                case 2:
                    _a.sent();
                    handleClose();
                    props.onTeamCreated();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    logger.error("Failed to create team", error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleUpdateTeam = function () { return __awaiter(void 0, void 0, void 0, function () {
        var updates, updatedRoleIds, originalUserIds, updatedUserIds, originalRoleIds, name_1, roleIds, userIds, error_2;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    updates = {};
                    updatedRoleIds = roles.filter(function (role) { return role.isChecked && role.name !== "custom"; }).map(function (role) { return role.id; });
                    originalUserIds = (_a = props.qteam) === null || _a === void 0 ? void 0 : _a.users.map(function (user) { return user.id; });
                    updatedUserIds = members.filter(function (member) { return member.id !== null; }).map(function (member) { return member.id; });
                    originalRoleIds = (_b = props.qteam) === null || _b === void 0 ? void 0 : _b.roles.map(function (role) { return role.id; });
                    if (teamName !== ((_c = props.qteam) === null || _c === void 0 ? void 0 : _c.name) && teamName.trim() !== "") {
                        updates.name = teamName;
                    }
                    if (!originalRoleIds || JSON.stringify(updatedRoleIds.sort()) !== JSON.stringify(originalRoleIds.sort())) {
                        updates.roleIds = updatedRoleIds;
                    }
                    if (!originalUserIds || JSON.stringify(updatedUserIds.sort()) !== JSON.stringify(originalUserIds.sort())) {
                        updates.userIds = updatedUserIds;
                    }
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 4, , 5]);
                    if (!(Object.keys(updates).length > 0)) return [3 /*break*/, 3];
                    name_1 = updates.name, roleIds = updates.roleIds, userIds = updates.userIds;
                    return [4 /*yield*/, ApiManager_1.default.updateQteam((_d = props.qteam) === null || _d === void 0 ? void 0 : _d.id, name_1, roleIds, userIds)];
                case 2:
                    _e.sent();
                    handleClose();
                    if (props.onTeamCreated)
                        props.onTeamCreated();
                    _e.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    error_2 = _e.sent();
                    logger.error("Failed to update team", error_2);
                    return [3 /*break*/, 5];
                case 5:
                    handleClose();
                    return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        var fetchRoles = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, rolesWithCheckState, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, ApiManager_1.default.getTeamRoles()];
                    case 1:
                        response = _a.sent();
                        rolesWithCheckState = response.map(function (role) { return (__assign(__assign({}, role), { isChecked: false })); });
                        rolesWithCheckState.push({ id: 0, name: "custom", display_name: "roles.customRole", description: "roles.customRoleDescription", group: 0, order: 4, isChecked: false });
                        setRoles(rolesWithCheckState);
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        console.error("Failed to fetch roles", error_3);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        fetchRoles();
    }, []);
    (0, react_1.useEffect)(function () {
        var fetchUsers = function () { return __awaiter(void 0, void 0, void 0, function () {
            var accountId, usersResponse, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        accountId = page.props.session.current_account.id;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, ApiManager_1.default.getUsersForAccountByAccountId(accountId)];
                    case 2:
                        usersResponse = _a.sent();
                        setUsers(usersResponse);
                        return [3 /*break*/, 4];
                    case 3:
                        error_4 = _a.sent();
                        logger.error("Failed to fetch users:", error_4);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        fetchUsers();
    }, []);
    (0, react_1.useEffect)(function () {
        if (props.qteam) {
            setTeamName(props.qteam.name);
            if (props.qteam.users.length === 0) {
                setMembers([{ id: null, name: "" }]);
            }
            else {
                setMembers(props.qteam.users.map(function (user) { return (__assign(__assign({}, user), { userId: user.id })); }));
            }
            setRoles(function (prevRoles) {
                var updatedRoles = prevRoles.map(function (role) { return (__assign(__assign({}, role), { isChecked: !!props.qteam.roles.find(function (r) { return r.id === role.id; }) })); });
                if (updatedRoles.filter(function (role) { return role.group !== 0; }).some(function (role) { return role.isChecked; })) {
                    var customRoleIndex = updatedRoles.findIndex(function (role) { return role.name === "custom"; });
                    updatedRoles[customRoleIndex].isChecked = true;
                }
                return updatedRoles;
            });
        }
    }, [props.qteam, props.toggle]);
    (0, react_1.useEffect)(function () {
        var _a, _b;
        var isTeamNameEmpty = !teamName;
        var noCheckedRoles = roles.filter(function (role) { return role.name !== "custom"; }).every(function (role) { return !role.isChecked; });
        var lockedQteamCheck = (((_a = props.qteam) === null || _a === void 0 ? void 0 : _a.locked) && ((_b = members[0]) === null || _b === void 0 ? void 0 : _b.id) == null);
        setIsButtonDisabled(isTeamNameEmpty || noCheckedRoles || lockedQteamCheck);
    }, [teamName, members, roles]);
    var body = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { style: { display: "flex", justifyContent: "space-between" } },
            react_1.default.createElement("div", { style: { flex: "1 1 50%", paddingRight: "20px" } },
                react_1.default.createElement("div", { style: { marginBottom: "25px" } },
                    react_1.default.createElement("span", { className: CreateTeamModal_module_css_1.default.header_text_bold }, t("Team Name")),
                    react_1.default.createElement(q_play_components_2.Input, { value: teamName, onChange: function (e) { return setTeamName(e.target.value); }, style: { width: "95%" }, className: CreateTeamModal_module_css_1.default.urlInput, placeholder: t("My team"), dataCy: "teamNameInput" })),
                react_1.default.createElement("span", { className: CreateTeamModal_module_css_1.default.header_text_bold },
                    t("Team Roles"),
                    ":"),
                react_1.default.createElement(RoleCheckboxList_1.default, { changeHandler: handleRoleCheckboxChange, roles: roles.filter(function (role) { return role.group === 0; }) }),
                ((_a = roles.find(function (role) { return role.name == "custom"; })) === null || _a === void 0 ? void 0 : _a.isChecked) && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("hr", null),
                    react_1.default.createElement("span", { className: CreateTeamModal_module_css_1.default.header_text_bold },
                        t("User defined Roles"),
                        ":"),
                    react_1.default.createElement(RoleCheckboxList_1.default, { changeHandler: handleRoleCheckboxChange, roles: roles.filter(function (role) { return role.group !== 0; }) })))),
            react_1.default.createElement("div", { style: { flex: "1 1 50%", paddingLeft: "20px", flexDirection: "column", height: "200px" } },
                react_1.default.createElement("span", { className: CreateTeamModal_module_css_1.default.header_text_bold },
                    t("Team Members"),
                    ":"),
                react_1.default.createElement("div", { style: { width: "100%" } },
                    react_1.default.createElement("div", { className: CreateTeamModal_module_css_1.default.team_members_container }, members.map(function (member, index) { return (react_1.default.createElement("div", { key: index, className: CreateTeamModal_module_css_1.default.members_list, "data-cy": "teamMember" },
                        member.id ? (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(UserAvatar, { imageUrl: member.profile_photo_path, name: member.name, styleIndex: index }),
                            react_1.default.createElement("span", { className: CreateTeamModal_module_css_1.default.span_text }, member.name))) : (react_1.default.createElement("div", { className: "w-100" },
                            react_1.default.createElement(AutocompleteUserSelection_1.default, { users: users.filter(function (apiUser) { return !members.some(function (member) { return member.id === apiUser.id; }); }), member: member, handleMemberSelectionChange: handleMemberSelectionChange, label: t("User name") }))),
                        react_1.default.createElement(q_play_components_2.Button, { text: "-", onClick: function () { return removeAddedMember(index); }, style: {
                                marginLeft: "auto",
                                padding: "0 5px",
                                borderRadius: "5px",
                                backgroundColor: "var(--secondary-color)",
                                color: "var(--info-color)",
                                maxWidth: "18px",
                                minWidth: "18px"
                            }, dataCy: "removeTeamMember" }))); })),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(q_play_components_2.Button, { onClick: addMember, className: CreateTeamModal_module_css_1.default.add_member_button, text: "+", "data-cy": "AddMemberButton" })))))));
    var footer = (react_1.default.createElement("div", null,
        react_1.default.createElement(q_play_components_2.Button, { onClick: props.mode === "edit" ? handleUpdateTeam : handleCreateTeam, className: CreateTeamModal_module_css_1.default.create_team_button, text: props.mode === "new" ? t("Create Team") : t("Update Team"), disabled: isButtonDisabled, "data-cy": "saveTeam" })));
    return (react_1.default.createElement(q_play_components_1.Modal, { isShown: props.isShown, onClose: handleClose, headerText: headerText, body: react_1.default.createElement("div", null, body), centered: true, footer: react_1.default.createElement("div", null, footer), dataCy: "CreateTeamModal", dialogClassName: CreateTeamModal_module_css_1.default.create_team_modal }));
};
exports.default = CreateTeamModal;
